import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import type { ChallengeExercises } from '../features/leaderboard/leaderboardApi';

interface ChallengeNavProps {
  courseId: string;
  challenge: ChallengeExercises;
}

/** Reminds the student they are playing the live challenge, with a way back to the standings. */
export function ChallengeBanner({ courseId, challenge }: ChallengeNavProps) {
  const { t } = useTranslation();
  return (
    <p
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '0.75rem',
        margin: 0,
        padding: '0.5rem 1rem',
        border: '1px solid var(--color-accent)',
        borderRadius: '0.5rem',
        fontWeight: 700,
      }}
    >
      <span>{t('leaderboard.challengeModeBanner', { chapter: challenge.chapterTitle })}</span>
      <Link to={`/courses/${courseId}/leaderboard`}>{t('leaderboard.viewLeaderboard')}</Link>
    </p>
  );
}
